<template>
  <GenericExplorer
    v-if="filters"
    :filters="filters"
    :views="available_views(is_mobile,views_props)"
    :is_mobile="is_mobile"
    
    @update="update_filters"
    :key="reload"
  />
  <!--
  :items_to_select="[filters.get_filter_value('pk')]"
  -->
</template>


<style lang="scss">
  @import "@/sass/explorer.scss";
</style>
  
  
<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import ExplorerDirectory from '@/components/explorer/ExplorerDirectory'
  import GenericExplorer from '@/components/explorer/GenericExplorer'
  import QUnitCollection from '@/qunit/QUnitCollection'
  import ChartsAPI from '@/api/ChartsAPI';
  import { QFilters, url_to_filters, get_qfilter } from '@/qunit/filters';
  
  export default {
    name: 'GenericExplorerView',
  
    components: {
      GenericExplorer,
      ExplorerDirectory,
    },
 
    data: () => ({
      filters: null,//new QFilters(),
      props: {
          'ExplorerTable': {
            'selectable': true,
            'actions': true,
            'server_pagination': true,
            'navigate': false,
            'function': QUnitCollection.explore,
            'filter_list': [
              'FilterCentro',
              'FilterProcess',
              'FilterSearch',
              'FilterDatesRange',
              'FilterAdvanced',
            ],
          },
          'ExplorerCalendar': {
            'actions': true,
            'function': QUnitCollection.exploreCalendar,
            'filter_list': [
              'FilterCentro',
              'FilterProcess',
              'FilterSearch',
              'FilterAdvanced',
            ],
          },
          'ExplorerCard': {
            'actions': true,
            'function': QUnitCollection.explore,
            'filter_list': [
              'FilterCentro',
              'FilterProcess',
              'FilterSearch',
              'FilterDatesRange',
              'FilterAdvanced',
            ],
          },
          'ExplorerCharts': {
            'function': () => {},
            /*'header_props' : {
              'hide_templates': true,
            },*/
            'filter_list': [
              'FilterCentro',
              'FilterProcess',
              'FilterSearch',
              'FilterDatesRange',
              'FilterAdvanced',
            ],
          },
        },
      force: false,
      reload: false,
    }),
  
    computed: {
      ...mapGetters([
        'site_id',
        'centro_id'
      ]),
      ...mapState(['explorer_filters','bpmap','is_mobile']),

      views_props() {
        let props =  this.props;
        props['ExplorerTable'].expandable = !this.is_mobile;
        props['ExplorerCharts'].function = this.chart_update;
        return props;
      },
    },
 
    mounted() {
      this.populate_filters();
    },
 
    methods: {
      ...mapActions(['SET_EXPLORER_FILTERS']),
 
      populate_filters() {
        this.filters = url_to_filters({...this.$route.query,site: this.sitePath});
        this.filters.set_filter(get_qfilter('centro',this.centro_id));
        const pk_filter = this.filters.get_filter('pk');
        if (pk_filter) {
          this.filters.set_filter(pk_filter,true);
        }
      },
  
      update_filters(ef) {
        this.SET_EXPLORER_FILTERS(ef);
      },

      available_views(is_mobile,props) {
        //Table
        let views = [{name: 'ExplorerTable',...props['ExplorerTable']}];
        
        if (is_mobile) {
          //Cards
          views.push({name: 'ExplorerCard',...props['ExplorerCard']});
        }
        //Calendar
        views.push({name: 'ExplorerCalendar',...props['ExplorerCalendar']});

        //Charts
        if (!this.is_mobile && (this.bpmap.get_value(this.filters.get_filter_value('business_process'))||{}).has_charts) {
          views.push({name: 'ExplorerCharts',...props['ExplorerCharts']});
        }
        
       return views;
      },

      // Charts method
      async chart_update(filters, cancel_token) {
        return await ChartsAPI.view(
          this.centro_id, // TODO: Update when site is no longer a path
          filters,
          cancel_token
        ).then((data)=> {
          this.props['ExplorerCharts'].charts = data;
          this.props = {...this.props}
          return null;
        });
      },
    },
  
    watch: {
      '$route': function() {
        this.populate_filters();
        
        /*
          Problems with a view and the population of the filters

          When navigation from calendar view, it propagates the change of filters, but changing the route, it propagates the new route filters
          This completly mess the current filters.

          SOLUTION, rebuild another GenericView so the calendar propagation doesn't affects the filters.
        */
        this.reload = !this.reload;
      },
  
      '$route.query.business_process': {
        handler() {
          /* this.populate_filters(); */
        },
        deep: true,
        immediate: true,
      },
    },
  }
</script>
  
